import AmexExperientialBanner from './AmexExperientialBanner';

export default AmexExperientialBanner;
